import { useMemo } from 'react';
import { AppScrollArea } from '@/components/ui/AppScrollArea';
import type { ViewerProps } from '../FilePreviewModal.types';
import styles from '../FilePreviewModal.module.css';

export function TextViewer({ data }: ViewerProps) {
  const text = useMemo(() => new TextDecoder('utf-8').decode(data), [data]);

  return (
    <AppScrollArea className={styles.textContainer} type="auto">
      <pre className={styles.textContent}>{text}</pre>
    </AppScrollArea>
  );
}
